<template>
  <div class="blind-box-scan-qr" @click="setFocus">
    <HomeHeader />
    <img class="back-arrow" :src="backArrow" @click="goBack" />
    <img :src="scanQrIndicator" alt="Scan Qr Code untuk mulai" />
    <input ref="qr-input" type="text" class="qr-input" inputmode="none" @keydown.enter="onInputQr" />
    <blind-box-popup :is-visible="showQrNotFoundPopup" @close="showQrNotFoundPopup = false">
      <div class="please-wait-popup-content">
        <img :src="errorCode === 'VOUCHER_EXPIRED' ? voucherExpiredImg : qrNotFoundImg" />
        <template v-if="errorCode === 'VOUCHER_ALREADY_USED'">
          <h2>Maaf QR Sudah Terpakai</h2>
        </template>
        <template v-else-if="errorCode === 'VOUCHER_EXPIRED'">
          <h2>Tiket Tidak Berlaku</h2>
          <p>
            Maaf Bestie, tiket Blind Box-mu tidak dapat digunakan. Coba tiket lainnya, atau hubungi Beauty Advisor untuk
            bantuan.
          </p>
        </template>
        <template v-else>
          <h2>Scan Gagal :(</h2>
          <p>Yuk, scan ulang untuk coba lagi atau hubungi BA kami!</p>
        </template>
        <div class="button-container">
          <button @click="onClickRescan">Scan Ulang</button>
          <button @click="goToBlindBox">Batalkan</button>
        </div>
      </div>
    </blind-box-popup>
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
const MINUTE = 60;
const SECOND = 1000;

export default {
  components: {
    HomeHeader: () => import('./layout/header.vue'),
    BlindBoxPopup: () => import('./ui/blind-box-popup.vue'),
  },
  data() {
    return {
      loading: false,
      idleTimer: null,
      idleTimeout: 5 * MINUTE * SECOND, // 5 minutes
      showQrNotFoundPopup: false,
      errorCode: '',
      scanQrIndicator: '/static/img/blind-box/scan/scan-qr-code-indicator.svg',
      qrNotFoundImg: '/static/img/blind-box/scan/qr-not-found.svg',
      voucherExpiredImg: '/static/img/blind-box/scan/voucher-expired.svg',
      backArrow: '/static/img/blind-box/global/back-arrow.svg',
    };
  },
  mounted() {
    const storeDetail = Cookies.get('store_detail');
    if (!storeDetail) {
      this.$router.replace('/');
    }
    this.setFocus();
    this.startIdleTimer();
    this.addIdleListeners();
  },
  beforeDestroy() {
    this.clearIdleTimer();
    this.removeIdleListeners();
  },
  methods: {
    goBack() {
      this.$router.replace('/blind-box/');
      this.clearIdleTimer();
      this.removeIdleListeners();
    },
    onClickRescan() {
      this.showQrNotFoundPopup = false;
      this.setFocus();
    },
    goToBlindBox() {
      this.$router.replace('/blind-box');
    },
    resetIdleTimer() {
      this.clearIdleTimer();
      this.startIdleTimer();
    },
    startIdleTimer() {
      this.idleTimer = setTimeout(() => {
        this.$router.replace('/blind-box');
      }, this.idleTimeout);
    },
    clearIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    },
    addIdleListeners() {
      ['mousemove', 'keydown', 'click', 'touchstart'].forEach((event) =>
        window.addEventListener(event, this.resetIdleTimer)
      );
    },
    removeIdleListeners() {
      ['mousemove', 'keydown', 'click', 'touchstart'].forEach((event) =>
        window.removeEventListener(event, this.resetIdleTimer)
      );
    },
    setFocus() {
      if (this.$refs['qr-input']) {
        this.$refs['qr-input'].focus();
        this.$refs['qr-input'].value = '';
      }
    },
    onInputQr(input) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const voucherCode = input.target.value;
      const redeemUrl = `${Config.MS_SOCO_PUBLIC_API_URL}/voucher/${voucherCode}/blind-box`;
      this.$axios
        .post(redeemUrl)
        .then((response) => {
          console.log(response);
          if (response.data && response.data.success) {
            this.$store.dispatch('setActiveBlindBoxVoucher', voucherCode);
            this.$router.replace(`/blind-box/select`);
          } else {
            console.log('bad request');
            this.errorCode = response.errorCode;
            this.showQrNotFoundPopup = true;
          }
        })
        .catch((error) => {
          this.errorCode = error.response?.data?.errorCode;
          console.log(this.errorCode);
          this.showQrNotFoundPopup = true;
        })
        .finally(() => {
          this.loading = false;
          this.setFocus();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './font/font.scss';
$bg-gradient: linear-gradient(180deg, #327fff 0%, #b0ceff 100%);
$footer-image-background: url('/static/img/blind-box/scan/scan-footer-new.svg') no-repeat bottom center;
$footer-size: 100% auto;

$pole-image-background: url('/static/img/blind-box/global/pole.png') no-repeat bottom center;
$pole-size: 40px 90vh;

.blind-box-scan-qr {
  background: $footer-image-background, $pole-image-background, $bg-gradient;
  background-size: $footer-size, $pole-size;
  height: 100vh;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  .qr-input {
    position: absolute;
    top: -1000px;
    opacity: 0;
  }
}

.back-arrow {
  position: fixed;
  top: 50px;
  left: 52px;
  width: 100px;
  height: 100px;
  cursor: pointer;
}

.please-wait-popup-content {
  background: #ffffff;
  border-radius: 16px;
  padding: 40px 42px;
  width: 520px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
  p {
    font-size: 30px;
  }
  img {
    height: 195px;
  }

  h2 {
    font-weight: 700;
    font-size: 40px;
    letter-spacing: 0.5px;
    text-align: center;
    color: #000000;
    margin: 48px 0 24px 0;
  }

  span {
    font-weight: 400;
    font-size: 30px;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
    color: #716a68;
  }
}

.button-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 32px;

  button {
    width: 100%;
    padding: 16px 0;
    font-size: 18px;
    font-weight: 600;
    border-radius: 40px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  button:first-child {
    background-color: #000000;
    color: #ffffff;
    border: none;
    font-size: 28px;
    margin-bottom: 16px;
  }

  button:last-child {
    background-color: #ffffff;
    color: #000000;
    border: 2px solid #000000;
    font-size: 28px;
  }
}
</style>
